import { render, staticRenderFns } from "./MainContacts.view.vue?vue&type=template&id=4c23d789"
import script from "./MainContacts.view.vue?vue&type=script&lang=js"
export * from "./MainContacts.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports